import { mainSiteUrl } from '@/mocks/categories';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-medium text-accent-600 uppercase tracking-widest mb-3">Trusted Sourcing Data</p>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 leading-tight">
            Mulebuy <span className="italic font-serif text-accent-500">Spreadsheet</span> Buyers
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            Organize your agent purchases with verified data from trusted sources across the Mulebuy ecosystem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-accent-100 rounded-2xl p-8 md:p-10 relative overflow-hidden group cursor-default">
            <div className="relative z-10">
              <div className="text-5xl md:text-6xl font-heading font-bold text-accent-700">50K+</div>
              <p className="mt-3 text-sm md:text-base text-foreground-800 leading-relaxed">
                Active users relying on <strong>mulebuy spreadsheet</strong> data for their daily sourcing decisions across multiple product categories and agent networks.
              </p>
              <p className="mt-4 text-sm italic text-accent-600 font-heading">Growing every day</p>
            </div>
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-accent-500">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </div>
          </div>

          <div className="bg-primary-100 rounded-2xl p-8 md:p-10 relative overflow-hidden group cursor-default">
            <div className="relative z-10">
              <div className="text-5xl md:text-6xl font-heading font-bold text-primary-700">99%</div>
              <p className="mt-3 text-sm md:text-base text-foreground-800 leading-relaxed">
                Data accuracy rate for verified <strong>mulebuy spreadsheet lists</strong> — ensuring every product price, agent detail, and availability status is current and actionable for your purchasing workflow.
              </p>
              <p className="mt-4 text-sm italic text-primary-600 font-heading">Verified daily</p>
            </div>
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-primary-500">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-background-100 rounded-2xl p-8 md:p-10">
          <h3 className="text-xl font-heading font-bold text-foreground-900 mb-5">Safety &amp; Transparency</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-foreground-600 leading-relaxed">
            <div>
              <p className="mb-3">
                <strong>We do not sell products directly.</strong> All <strong>mulebuy spreadsheet data</strong> is collected from publicly available sources and user submissions. Users should verify information independently before making any purchase decisions.
              </p>
              <p>
                This site contains affiliate links to{' '}
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">
                  Kaspreadsheet
                </a>
                . We may earn a commission at no extra cost to you when you click through and make a purchase.
              </p>
            </div>
            <div>
              <p className="mb-3">
                <strong>Data accuracy disclaimer:</strong> While we strive to keep our mulebuy spreadsheet resources updated, product availability, pricing, and agent information may change rapidly. Always cross-reference with the official platform.
              </p>
              <p>
                <strong>Risk notice:</strong> All purchasing decisions made through linked platforms are your responsibility. We recommend due diligence before any transaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}